export const COMPACT_LOGO_CLASS = 'size-6';

export const COMPACT_WORDMARK_CLASS = 'h-3.75';

export const SIDEBAR_BUTTON_CLASS = [
  'rounded-xl h-auto gap-2 px-2.5 py-1.5 transition-all duration-300 ease-in-out',
  '[&>svg]:transition-[width,height,color] [&>svg]:duration-300 [&>svg]:ease-in-out',
  '[&>svg:first-child]:size-6',
  'text-sidebar-foreground',
  'hover:bg-muted/60',
  'data-active:bg-sidebar-active/16 data-active:font-semibold data-active:text-sidebar-active',
  'data-active:hover:bg-sidebar-active/20 data-active:[&>svg:first-child]:text-sidebar-active',
  'group-data-[collapsible=icon]:data-active:bg-sidebar-active/16',
  'group-data-[collapsible=icon]:p-(--sidebar-rail-inset)! group-data-[collapsible=icon]:[&>svg:first-child]:size-5',
].join(' ');

export const MENU_LABEL_CLASS = 'truncate text-sm font-medium';

export const SECTION_CLASS = 'gap-1 p-0';

export const SECTION_LABEL_CLASS =
  'h-5 px-0 text-2xs font-semibold uppercase tracking-widest leading-5 text-muted-foreground/70 truncate group-data-[collapsible=icon]:-mt-5';

export const SECTION_SEPARATOR_CLASS =
  'mx-2.5 h-px bg-transparent bg-linear-to-r from-transparent via-sidebar-accent to-transparent';

export const SIDEBAR_SUB_BUTTON_CLASS = [
  'rounded-lg h-auto px-2.5 py-1.5 transition-all duration-300 ease-in-out',
  'text-sidebar-foreground/85',
  'hover:bg-muted/60 hover:text-sidebar-accent-foreground',
  'data-active:bg-sidebar-active/16 data-active:font-semibold data-active:text-sidebar-active',
  'data-active:hover:bg-sidebar-active/20 data-active:hover:text-sidebar-active',
].join(' ');

export const DISABLED_BUTTON_CLASS =
  'cursor-not-allowed opacity-60 pointer-events-none hover:bg-transparent hover:text-muted-foreground';

export const CHEVRON_TRANSITION_CLASS = 'transition-transform duration-300 ease-in-out';
export const CHEVRON_OPEN_CLASS = 'rotate-180';

export const COLLAPSIBLE_CONTENT_CLASS =
  'overflow-hidden h-(--collapsible-panel-height) transition-[height] duration-300 ease-in-out data-starting-style:h-0 data-ending-style:h-0';

export const SUBMENU_CONTAINER_CLASS =
  'flex min-w-0 flex-col gap-1 border-l border-sidebar-border mx-0 ml-4 px-0 pl-2 py-1';

export const VENDOR_CREDIT_CLASS = [
  'gap-0 transition-[padding,background-color] duration-300 ease-in-out motion-reduce:transition-none group-data-[collapsible=icon]:px-0',
  '[&>span]:ml-1.5 [&>span]:max-w-48 [&>span]:overflow-hidden [&>span]:opacity-100',
  '[&>span]:transition-[max-width,margin,opacity] [&>span]:duration-300 [&>span]:ease-in-out motion-reduce:[&>span]:transition-none',
  'group-data-[collapsible=icon]:[&>span]:ml-0 group-data-[collapsible=icon]:[&>span]:max-w-0 group-data-[collapsible=icon]:[&>span]:opacity-0',
].join(' ');

export const FOOTER_SEPARATOR_CLASS =
  'mx-6 h-px shrink-0 bg-transparent bg-linear-to-r from-transparent via-sidebar-accent to-transparent transition-[margin] duration-300 ease-in-out motion-reduce:transition-none group-data-[collapsible=icon]:mx-2';

export const SIDEBAR_FOOTER_CLASS =
  'px-6 py-4 transition-[padding] duration-300 ease-in-out motion-reduce:transition-none group-data-[collapsible=icon]:px-4.5';

export const SUBMENU_ACTIVE_INDICATOR_CLASS =
  "relative before:absolute before:-left-2.5 before:inset-y-0 before:w-0.5 before:rounded-full before:bg-sidebar-active before:content-['']";
